module.exports = __webpack_public_path__ + "img/paintscuffs.136c2a4c.jpeg";